import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';

// import InfoOutline from "@material-ui/icons/InfoOutline";
import Language from '@material-ui/icons/Language';

// core components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardBody from 'components/Card/CardBody.js';
import CardFooter from 'components/Card/CardFooter.js';
import styles from 'assets/jss/material-dashboard-pro-react/views/dashboardStyle.js';
import moment from 'moment';

import { Polygon } from '@react-google-maps/api';
import wkt from 'wkt';

import { wsFindBy, wsGetAll } from 'services/WService';
import BarChart from 'components/Tvendo/Common/BarChart';
import LineChart from 'components/Tvendo/Common/LineChart';
import { WithApp } from 'contexts/appContext';
import { TextField } from '@material-ui/core';
import { AssignmentInd, AssignmentTurnedIn, Timelapse } from '@material-ui/icons';
import { currency, nInt, nPercent } from 'hooks/Pipe';
import InvalidAvgPrice from './InvalidAvgPrice';
import GoogleMapCustom from 'components/Tvendo/Common/GoogleMapCustom';

const ica_flag = require('assets/img/flags/Ica.png');

const styleDashboard = {
  ...styles,
  table: {
    minWidth: 350
  }
};

const useStyles = makeStyles(styleDashboard);

export default WithApp(function Dashboard(props) {
  const location = useLocation();
  const classes = useStyles();

  const [mapRef, setMapRef] = useState(null); //props del mapa cargado
  const [mapCenter, setMapCenter] = useState({
    lat: -14.075411072797454,
    lng: -75.7341740473886
  }); //centro para la carga inicial del mapa

  const [date, setDate] = useState(moment().format());

  const [zones, setZones] = useState([]);
  const [zoneSelected, setZoneSelected] = useState(null);
  const [totalCuota, setTotalCuota] = useState({ quota: 0, sale: 0 });
  const [checked, setChecked] = useState(false);
  const [monthSelected, setMonthSelected] = useState('');
  const [nameProviders, setNameProviders] = useState([]);
  const [salesProviders, setSalesProviders] = useState([]);
  const [invalidStocks, setInvalidStocks] = useState([]);
  const [salesDays, setSalesDays] = useState([]); //falta data
  const [customers, setCustomers] = useState({});

  async function getDataSales(date, type, zoneSelected) {
    let filter = {};

    if (!!date) {
      filter.date = date;
    }
    if (!!type) {
      filter.type = type;
    }
    if (zoneSelected !== null) {
      filter.base_zone_id = zoneSelected;
    }

    for (var clave in filter) {
      if (filter[clave] == null) {
        delete filter[clave]; //eliminamos solo las claves vacias
      }
    }
    let response;
    if (Object.keys(filter).length > 0) {
      response = await wsFindBy('dashboard/admin', filter);
    } else {
      response = await wsGetAll('dashboard/admin');
    }

    if (response.success) {
      setMonthSelected(filter.date);

      for (let i = 0; i < response.data.zone_quotas?.length; i++) {
        let row = response.data.zone_quotas[i];
        if (!!row.geometry) {
          row.geometry = wkt.parse(row.geometry).coordinates[0].map((point) => {
            return {
              lng: point[0],
              lat: point[1]
            };
          });
        }
      }
      /* let total = 0; */
      /* for (let item of ) {
        total += parseFloat(item.quota);
      } */
      setTotalCuota({
        quota: response.data?.zone_quotas
          ?.reduce((a, b) => a + parseFloat(b.quota || 0), 0)
          .toFixed(2),
        sale: response.data?.zone_quotas
          ?.reduce((a, b) => a + parseFloat(b.progress || 0), 0)
          .toFixed(2)
      });
      setZones(response.data.zone_quotas);
      if (response.data.sales_by_provider?.length > 0) {
        let nameProvider = response.data.sales_by_provider.map((item) => {
          return item.CardFName?.substring(0, 3);
        });
        setNameProviders(nameProvider);

        let total_amount = response.data.sales_by_provider.map((item) => {
          let total = parseFloat(item.total_amount || 0).toFixed(2);
          return parseFloat(total);
        });
        setSalesProviders(total_amount);
      }
      setCustomers(response.data.customers);
      setSalesDays(response.data.month_sales.data);

      let notificationData = JSON.parse(localStorage.getItem('notifications'));
      if(response.data.invalid_stocks.length > 0){
        setInvalidStocks(response.data.invalid_stocks);

        let newData = {
          id: 'avg_price_invalid',
          text: `Hay ${response.data.invalid_stocks.length} productos con precio promedio inválido`,
          action: 'redirect:/admin/dashboard#avgprice',
        };

        if(notificationData === null){
          localStorage.setItem(
            'notifications',
            JSON.stringify([newData]),
          );
        }else{
          let existentIndex = notificationData.findIndex(noty => noty.id === 'avg_price_invalid');
          if(existentIndex === -1){
            // No existe la notificación, agregar
            notificationData.push(newData);
            localStorage.setItem('notifications', JSON.stringify(notificationData));
          }else{
            // Reemplazar data de notificación
            notificationData.splice(existentIndex, 1, newData);
            localStorage.setItem('notifications', JSON.stringify(notificationData));
          }
        }
      }else{
        let existentIndex = notificationData.findIndex(noty => noty.id === 'avg_price_invalid');
        notificationData.splice(existentIndex, 1);
        localStorage.setItem('notifications', JSON.stringify(notificationData));
      }
    }
  }

  useEffect(() => {
    setMapCenter({
      lat: -14.075411072797454,
      lng: -75.7341740473886
    });
    getDataSales();
  }, []);

  useEffect(() => {
    if(location.hash === '#avgprice'){
      document.querySelector(location.hash).scrollIntoView();
    }
  }, [location.hash]);

  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={6} md={6} lg={3}>
          <Card>
            <CardHeader color="success" stats icon>
              <CardIcon color="success">
                <AssignmentInd />
              </CardIcon>
              <p className={classes.cardCategory}>Clientes</p>
              <h3 className={classes.cardTitle}>{nInt(customers.total)}</h3>
            </CardHeader>
            <CardFooter stats></CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={6} lg={3}>
          <Card>
            <CardHeader stats icon>
              <CardIcon color="danger">
                <AssignmentTurnedIn />
              </CardIcon>
              <p className={classes.cardCategory}>Clientes visitados</p>
              <h3 className={classes.cardTitle}>{nInt(customers.visited)}</h3>
            </CardHeader>
            <CardFooter stats></CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={6} lg={3}>
          <Card>
            <CardHeader stats icon>
              <CardIcon color="info">
                <Timelapse />
              </CardIcon>
              <p className={classes.cardCategory}>Efectividad</p>
              <h3 className={classes.cardTitle}>{nPercent(customers.effectiveness)}</h3>
            </CardHeader>
            <CardFooter stats></CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={6} lg={3}>
          <Card>
            <CardHeader stats icon>
              <CardIcon color="warning">
                <Icon>content_copy</Icon>
              </CardIcon>
              <p className={classes.cardCategory}>Cobertura</p>
              <h3 className={classes.cardTitle}>{nPercent(customers.coverage)}</h3>
            </CardHeader>
            <CardFooter stats></CardFooter>
          </Card>
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader icon>
              <CardIcon color="success">
                <Language />
              </CardIcon>
              <div className={classes.cardIconTitle}>
                <h4>Datos por zona</h4>
              </div>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={12} md={5}>
                  <TextField
                    label="Fecha"
                    type={checked ? 'month' : 'date'}
                    margin="normal"
                    name="date"
                    value={moment(date).format(checked ? 'YYYY-MM' : 'YYYY-MM-DD')}
                    onChange={(e) => {
                      setDate(e.target.value);
                      getDataSales(e.target.value, checked ? 'P' : 'D', zoneSelected);
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <TableContainer component={Paper}>
                    <Table className={classes.table} size="small" aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell width={50}>
                            <Button
                              justIcon
                              size="sm"
                              onClick={() => {
                                setChecked(!checked);
                                getDataSales(date, !checked ? 'P' : 'D', zoneSelected);
                              }}
                              color={
                                checked
                                  ? props.themeContext.buttonColor
                                  : props.themeContext.buttonColorWarning
                              }
                            >
                              {checked ? 'P' : 'D'}
                            </Button>
                          </TableCell>
                          <TableCell width={50}>Periodo</TableCell>
                          <TableCell width={100}>Zona</TableCell>
                          <TableCell width={100}>Cuota</TableCell>
                          <TableCell width={100}>Venta</TableCell>
                          <TableCell width={100}>Avance</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {zones.map((zone, i) => (
                          <TableRow
                            key={i}
                            style={{
                              backgroundColor:
                                zone.base_zone_id == zoneSelected ? '#fe9f1b40' : 'white',
                              cursor: 'pointer',
                            }}
                            onClick={() => {
                              setZoneSelected(zone.base_zone_id);
                              getDataSales(date, checked ? 'P' : 'D', zone.base_zone_id);
                            }}
                          >
                            <TableCell>
                              <img src={ica_flag} alt="us_flag" key={'flag'} />
                            </TableCell>
                            <TableCell>{zone.period}</TableCell>
                            <TableCell>{zone.base_zone_description}</TableCell>
                            <TableCell align="right">{currency(zone.quota || 0)}</TableCell>
                            <TableCell align="right">{currency(zone.progress || 0)}</TableCell>
                            <TableCell align="center">
                              {nPercent(zone.progress_percentage)}
                            </TableCell>
                          </TableRow>
                        ))}
                        <TableRow>
                          <TableCell align="right" colSpan={3}>
                            Total:
                          </TableCell>
                          <TableCell align="right">{currency(totalCuota.quota)}</TableCell>
                          <TableCell align="right">{currency(totalCuota.sale)}</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </GridItem>
                <GridItem xs={12} sm={12} md={7}>
                  <GoogleMapCustom
                    onLoad={(map) => {
                      setMapRef(map);
                    }}
                    mapContainerStyle={{
                      width: '100%',
                      height: '100%',
                      minHeight: '300px',
                    }}
                    zoom={8}
                    center={mapCenter}
                  >
                    {zones.map((zone, i) => {
                      return !!zone.geometry ? (
                        <Polygon
                          key={i}
                          paths={zone.geometry}
                          options={{
                            fillColor: zone.base_zone_id == zoneSelected ? '#fb8d01' : '#00acc1',
                          }}
                          onClick={() => {
                            setZoneSelected(zone.base_zone_id);
                            getDataSales(date, checked ? 'P' : 'D', zone.base_zone_id);
                          }}
                        />
                      ) : undefined;
                    })}
                  </GoogleMapCustom>
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem md={12} lg={5}>
          <LineChart
            data={salesDays}
            title="Venta diaria del mes en curso"
            subTitle="Más info"
            lastUpdate="4 min"
            refresh={getDataSales}
            monthSelected={monthSelected}
            date={date}
          />
        </GridItem>
        <GridItem md={12} lg={7}>
          <BarChart
            labels={nameProviders}
            data={salesProviders}
            title="Venta por proveedores"
            subTitle="Más info"
            lastUpdate="4 min"
            refresh={getDataSales}
            date={date}
            formatDate={checked ? 'P' : 'D'}
          />
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem md={12} lg={7}>
          <InvalidAvgPrice invalidStocks={invalidStocks} setInvalidStocks={setInvalidStocks} />
        </GridItem>
      </GridContainer>
    </div>
  );
});
